import { LumberProfileCatalog } from "building-types/framing/lumberTypes";
import { RoofFramingComponentType } from "building-types/framing/roofFramingComponentTypes";
import { RoofFramingType, type RoofTruss } from "building-types/framing/roofFramingTypes";
import { RoofTrussType, type RoofTrussBasicInput } from "building-types/framing/roofTrussTypes";
import { lumberPiecesByProfileNew } from "doc/utils/lumberTools";
import { planeNormal } from "geom/plane";
import type { TrussGenerator } from "./trussGenerator";
import { generateTopChords, projectChordsToFramingPlane, setupTopChordRails } from "./trussUtils";

export class FlyTrussGenerator implements TrussGenerator {
  generate(input: RoofTrussBasicInput): RoofTruss {
    const {
      leftSpan,
      leftEaveFasciaSize,
      rightSpan,
      rightEaveFasciaSize,
      leftTopChordPitch,
      rightTopChordPitch,
      topChordProfile,
      trussPlane,
    } = input;

    if (Array.isArray(leftSpan) || Array.isArray(rightSpan)) {
      throw new Error("Fly truss does not support multiple spans");
    }

    const { left, right } = generateTopChords(leftSpan, rightSpan, leftTopChordPitch, rightTopChordPitch);

    const [leftTopChordTopPointsToFramingPlane, rightTopChordTopPointsToFramingPlane] = projectChordsToFramingPlane(
      [left, right],
      input.trussPlane,
    );

    const topChords = lumberPiecesByProfileNew(LumberProfileCatalog[topChordProfile], { [topChordProfile]: [] });
    const [normX, normY, normZ] = planeNormal(input.trussPlane);

    setupTopChordRails(topChords, leftTopChordTopPointsToFramingPlane, leftEaveFasciaSize, normX, normY, normZ);
    setupTopChordRails(topChords, rightTopChordTopPointsToFramingPlane, rightEaveFasciaSize, normX, normY, normZ);

    return {
      trussType: RoofTrussType.FLY_TRUSS,
      components: [{ type: RoofFramingComponentType.TOP_CHORD, lumber: topChords }],
      framingType: RoofFramingType.TRUSS,
      plane: trussPlane,
    };
  }
}
